import { VoucherType } from "@tm/models"
import { useLocalization } from "@tm/localization"
import { Loader, Card, Typography, Box, Stack } from "@tm/components"
import { useRecoilState } from "recoil"
import { voucherListFilterAtom } from "@bundles/vouchers/data/states/listFilters"
import { isAfter, isBefore } from "date-fns"
import VoucherHeader from "../_shared/VoucherDetailsHeader"
import { useReturnDetails } from "../../../../business/hooks/useReturnDetails"
import ReturnsPartsTable from "./components/PartsTable/Index"

type Props = {
    workTaskId: string
    voucherId: string | undefined
    onShowOrder(voucherId: string): void
}

export function ReturnDetails({ workTaskId, voucherId, onShowOrder }: Props) {
    const { translateText } = useLocalization()
    const { returnDetails, returnDetailsLoading } = useReturnDetails(voucherId)
    const [listFilters, setListFilter] = useRecoilState(voucherListFilterAtom(workTaskId))

    if (returnDetailsLoading) {
        return <Loader />
    }

    if (!returnDetails) {
        return <Typography>{translateText(323)}</Typography>
    }

    const { items, voucherNumber, returnDate, returnRecipient, customerReturnNumber } = returnDetails
    if (isAfter(returnDate, listFilters.startDate) || isBefore(returnDate, listFilters.endDate)) {
        setListFilter((prev) => ({
            ...prev,
            startDate: returnDate,
            endDate: returnDate,
        }))
    }

    return (
        <Stack spacing={1}>
            <VoucherHeader
                type={VoucherType.Return}
                orderDate={returnDate}
                returnRecipient={returnRecipient}
                voucherNumber={voucherNumber}
                customOrderNumber={customerReturnNumber}
            />
            <Card>
                <Stack gap={1}>
                    <Typography variant="h3" p={1}>
                        {translateText(1667)}
                    </Typography>
                    <Box px={2} pb={1}>
                        <ReturnsPartsTable returnItems={items} onShowOrder={onShowOrder} isBigScreen />
                    </Box>
                </Stack>
            </Card>
        </Stack>
    )
}
